/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 2894
// module chunks = 0